import type { PageCollectionTheme } from '$lib/sanity/schemas';

interface RecursiveTheme {
  [key: string]: string | string[] | number | boolean | RecursiveTheme;
}

export const adaptPageCollectionThemeToTwistTheme = (theme: PageCollectionTheme) => {
  return {
    divider: {
      color: theme.general?.foregroundColor
    }
  } as RecursiveTheme;
};

export const themeStyleVars = (theme: RecursiveTheme, prefix = '--theme'): string => {
  const styleVars: string[] = [];

  const recursiveKebabCase = (theme: RecursiveTheme, current?: string) => {
    for (let accessor in theme) {
      const key = (current ? `${current}-${accessor}` : `${prefix}-${accessor}`)
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase();
      const value = theme[accessor];

      if (!!value && Array.isArray(value)) {
        continue;
      } else if (!!value && typeof value === 'object') {
        recursiveKebabCase(value, key);
      } else if (value) {
        styleVars.push(`${key}: ${value};`);
      }
    }
  };

  recursiveKebabCase(theme);

  return styleVars.join('');
};
